import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { StatsSection } from 'widgets/statspro/js/components/common/stats-section';
import { LocationDropdown } from './LocationDropdown';
import { RegionDropdown } from './RegionDropdown';

export const SelectionCallout = ({
    handleDropdownChange,
    locations,
    regions,
    selectedTimeZone
}) => {
    const [dropdownData, setDropdownData] = useState({
        activeLocation: PULSE.app.common.modifyCountryDisplay(
            selectedTimeZone.location
        ),
        activeRegion: selectedTimeZone.regionName
    });

    return (
        <div className="selection-callout__options-container">
            <StatsSection.Main>
                <StatsSection.Nav>
                    <StatsSection.NavItems>
                        <LocationDropdown
                            dropdownData={dropdownData}
                            items={locations}
                            setDropdownData={setDropdownData}
                            handleDropdownChange={handleDropdownChange}
                            classes={'competition-nav__region-wrapper'}
                            selectedTimeZone={selectedTimeZone}
                        />
                        <RegionDropdown
                            dropdownData={dropdownData}
                            items={regions}
                            setDropdownData={setDropdownData}
                            handleDropdownChange={handleDropdownChange}
                            classes={'competition-nav__region-wrapper'}
                            selectedTimeZone={selectedTimeZone}
                        />
                    </StatsSection.NavItems>
                </StatsSection.Nav>
            </StatsSection.Main>
        </div>
    );
};

SelectionCallout.propTypes = {
    locations: PropTypes.array,
    regions: PropTypes.array,
    handleDropdownChange: PropTypes.func,
    selectedTimeZone: PropTypes.object
};
